import { Get, type CListResponse, type CResponse, Post } from './server';

type GetApiResponse<T> = Promise<
  [any, CResponse<T> | undefined, CListResponse<T> | undefined]
>;
type PostApiResponse<T> = Promise<[any, CResponse<T> | undefined]>;

export function roleInfo<T>(params: any): GetApiResponse<T> {
  return Get<T>('/colg_connection_tencent-colg_connection_tencent.html/getRoleInfo',params);
}

export function questionList<T>(params: any): GetApiResponse<T> {
  return Get<T>('/colg_activity_new-colg_answer.html/getQuestionList', params);
}

export function achieveList<T>(params: any): GetApiResponse<T> {
  return Get<T>('/colg_activity_new-colg_answer.html/getAchieveList', params);
}

export function activityInfo<T>(params: any): GetApiResponse<T> {
  return Get<T>('/colg_activity_new-colg_answer.html/getInfo', params);
}

export function submitAnswer<T>(params: any, data: any): PostApiResponse<T> {
  return Post<T>('/colg_activity_new-colg_answer.html/submitAnswer',params,data);
}

export function shareInfo<T>(params: any): GetApiResponse<T> {
  return Get<T>('/colg_activity_new-colg_answer.html/getShareInfo', params);
}

export function getReward<T>(params: any, data: any): PostApiResponse<T> {
  return Post<T>('/colg_activity_new-colg_activity_new.html/getReward',params,data);
}
